module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/dashboard"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-ios-pie"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/report"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-ios-paper"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Reports")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/master/membershiptype"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Membership Type")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/master/membershipcategory"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Membership Category")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/master/guesttype"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Guest Type")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/master/gender"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Gender")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/master/maritalstatus"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Marital Status")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/master/bloodtype"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Blood Type")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/master/religion"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Religion")])])])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/membership"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-card"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Membership")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/group"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-contacts"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Group")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/guest"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("List of Guest")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/guest/guestmembership"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("List of Membership of Guest")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/checkinoutlocation"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-map-marker"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Check-in/out location")])])])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/sales/producttype"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Product Type")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/sales/productcategory"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Product Category")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/sales/product"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Product")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/sales/price"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Price")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/sales/salesorder"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Sales Order")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/sales/invoice"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Customer Invoice")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/sales/bin"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("BIN (Bank Identification)")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/sales/cardfee"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Card Fee")])])])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/pos/dashboard"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/pos/session"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Session")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/pos/order"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Order")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/pos/config"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("PoS Config")])])])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/payment/order"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("List of Orders")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/payment/payment"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("List of Payments")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/payment/clearing"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Payment Clearing")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/payment/clearingsession"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("List of Clearing Payments")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/payment/clearingdetail"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("List of Clearing Payments - Details")])])])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/gate/passcode"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Passcode")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/gate/gate"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("List of Gates")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/gate/paymentmethod"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Payment Methods")])])])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(6), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/reservation/court"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Court")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/reservation/reservation"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("List of Reservation")])])])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(7), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/settings/company"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Company")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/settings/project"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Project")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/settings/user"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("User")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/settings/bank"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Bank")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/settings/bankaccount"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Bank Account")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/settings/holiday"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Holiday Calendar")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/settings/workingcalendar"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Working Calendar")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(8), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/settings/authobject"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Authorization Objects")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/settings/authfield"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Authorization Fields")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/settings/role"
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon ion-android-arrow-dropright"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Role")])])])], 1)])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-folder"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Master Data")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "icon ion-ios-arrow-forward"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-person"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Guest")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "icon ion-ios-arrow-forward"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-connection-bars"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Sales Process")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "icon ion-ios-arrow-forward"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Point of Sales(PoS)")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "icon ion-ios-arrow-forward"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-cash"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("e-Payment")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "icon ion-ios-arrow-forward"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-checkmark-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Gate Management")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "icon ion-ios-arrow-forward"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-clipboard"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Reservation")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "icon ion-ios-arrow-forward"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-options"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "icon ion-ios-arrow-forward"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "icon ion-ios-arrow-forward"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71eaaf2b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SidebarMenu.vue
// module id = 752
// module chunks = 1